import { axiosInstance } from 'boot/axios.js'

export async function measures(ctx, queryParams = {}) {
  try {
    const response = await axiosInstance({
      url: 'bikes/measures',
      params: queryParams,
      method: 'GET'
    })
    ctx.commit('measures', response.data.items)
    return response
  } catch (e) {
    throw e
  }
}

export async function cycleTypes(ctx, queryParams = {}) {
  try {
    const response = await axiosInstance({
      url: 'cycle-types',
      params: queryParams,
      method: 'GET'
    })
    ctx.commit('cycleTypes', response.data.items)
    return response
  } catch (e) {
    throw e
  }
}

export async function cycleSegments(ctx, queryParams = {}) {
  try {
    const response = await axiosInstance({
      url: 'cycle-segments',
      params: queryParams,
      method: 'GET'
    })
    ctx.commit('cycleSegments', response.data.items)
    return response
  } catch (e) {
    throw e
  }
}

export async function cycleBeads(ctx, queryParams = {}) {
  try {
    const response = await axiosInstance({
      url: 'cycle-beads',
      params: queryParams,
      method: 'GET'
    })
    ctx.commit('cycleBeads', response.data.items)
    return response
  } catch (e) {
    throw e
  }
}
